var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHospitalinfoRecoveryroom = function SvgHospitalinfoRecoveryroom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6726",
    d: "M15.99 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.5 8.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M17.5 8.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M16 11.63c-1.03 0-1.88-.84-1.88-1.88h.75c0 .62.5 1.12 1.12 1.12s1.12-.5 1.12-1.12h.75c.02 1.04-.83 1.88-1.86 1.88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "M25.5 18.01h-19v6h19z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M13.5 18h-7v-3h4c1.66.01 3 1.35 3 3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    d: "M6.88 13.03h-.75v13h.75zM25.88 13.03h-.75v13h.75z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M6.48 26.98a1 1 0 1 0 0-2 1 1 0 0 0 0 2M25.5 26.98a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  })));
};
export default SvgHospitalinfoRecoveryroom;